import request from './request';

export function fetchSupplierInvoiceData(page) {
  return request(`supplier_invoices?page=${page || 1}`, {
    method: 'GET'
  });
}
